import React, { FC } from 'react'
import { useParams } from 'react-router-dom'

import { useSelector } from 'react-redux'
import { RootState } from '../../../states/containers/store'

const TeamContentsHeader: FC = () => {
  const {
    commonPart,
  } = useSelector((state: RootState) => state)

  const { id } = useParams<{ id: string | undefined }>()

  return (
    <div style={{ textAlign: "center", marginTop: "1.5em", marginBottom: "1.5em" }}>
      <div>
        <span style={{ fontSize: "32px", fontWeight: "bold", color: "#094E8D" }}>
          {commonPart.teams?.find((val) => val.id === Number(id))?.name}
        </span>
      </div>
    </div>
  )
}

export default TeamContentsHeader
